import { ClareServicePlan } from "@app/project/model";
import { createActionSet, createNoPropsAction } from "@app/root-store/actions/action-creators";
import { ClareDbCollection } from "@app/shared/resources/resource-objectifier";

interface LoadActionResult {
    servicePlans: ClareDbCollection<ClareServicePlan>;
}

export const { success: loadSuccess, failure: loadFailure } = createActionSet<null, LoadActionResult>("ServicePlan Management", "Load");
export const load = createNoPropsAction("ServicePlan Management", "Load");
